import { NgModule } from '@angular/core';
import { PhdSoftOrderByPipe } from './phdsoft-order-by.pipe';
import { PhdSoftFilterPipe } from './phdsoft-filter.pipe';
import { PhdSoftPathValuePipe } from './phdsoft-path-value.pipe';
import { PhdSoftDynamicPipe } from './phdsoft-dynamic.pipe';
import { OrderByPipe } from './order-by.pipe';

@NgModule({
  declarations: [
    PhdSoftFilterPipe,
    PhdSoftOrderByPipe,
    PhdSoftPathValuePipe,
    PhdSoftDynamicPipe,
    OrderByPipe
  ],
  imports: [
  ],
  exports: [
    PhdSoftFilterPipe,
    PhdSoftOrderByPipe,
    PhdSoftPathValuePipe,
    PhdSoftDynamicPipe,
    OrderByPipe
  ]
})
export class PhdSoftPipesModule { }
